import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  agentName: '',
  agentEntityId: '',
  agentSalesAgentCode: '',
  salesChannel: '',
};

const agentDetailsSlice = createSlice({
  name: 'agentDetails',
  initialState,
  reducers: {
    setAgentDetails: (_state, action) => action.payload,
  },
});

export const { setAgentDetails } = agentDetailsSlice.actions;
export default agentDetailsSlice.reducer;
